import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatTableModule } from '@angular/material/table';
import { ActionButtonComponent, ListFilterComponent } from '../../ui-kit';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { MatPaginatorModule } from '@angular/material/paginator';
import { UsersSelectionDialogComponent } from './users-selection-dialog.component';
import { IntrackFeatureModule } from '../../intrack-feature.module';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatChipsModule,
    MatTableModule,
    MatPaginatorModule,
    ListFilterComponent,
    MatCheckboxModule,
    ActionButtonComponent,
    MatDialogModule,
    RouterModule,
    TranslateModule.forChild({}),
    IntrackFeatureModule,
  ],
  exports: [UsersSelectionDialogComponent],
  declarations: [UsersSelectionDialogComponent],
})
export class UsersSelectionDialogModule {}
